import React from 'react';
import { fireScreenAnalytics, MountEvent } from '@atlassian/analytics-bridge';
import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';

const ViewTracker = () => (
	<MountEvent onMount={(analyticsEvent: UIAnalyticsEvent) => fireScreenAnalytics(analyticsEvent)} />
);

export default ViewTracker;
